<template>
    <div class="row" id="food" v-if="food.isActive">
        <div class="col-md-4">
            <div class="title-section-toggle">
                <div class="content-title-section">
                    <div class="icon-section">
                        <span class="ptw-icon icons-restaurant"></span>
                    </div>
                    <h3> {{ __("messages.typical_food") }} </h3>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="content-section-toggle">
                <div class="content-toggle ap_contentToggle_1"
                     :style="{ height: vHeigth, overflow: 'hidden', paddingBottom: '40px', transition: vTransition }">
                    <div class="ap_innerToggle">
                        <div class="col-md-12">
                            <div class="list-item-photo group">
                                <p class="h4"> {{ __("messages.dishes_not_miss") }} </p>
                                <div v-for="dish in food.dishes">
                                    <div class="item">
                                        <img :src="dish.image" :alt="dish.name" :title="dish.name" width="80" height="80">
                                        <p>
                                            <strong v-html="dish.name.replace(/<\/?p>/g, '')"></strong>
                                            <span v-html="dish.description.replace(/<\/?p>/g, '')"></span>
                                        </p>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div class="food-appinner">
                            <div class="food-appinner-description">
                                <h4>{{ __("messages.country_typical_food") }} {{city}}, {{ countryName }}</h4>
                            </div>
                            <div class="food-appinner-info" v-html="food.info">

                            </div>
                        </div>
                    </div>
                    <div class="action-toggle">
                        <a href="#" class="btnTertiary btnTertiary--xs action-link ap_actionToggle" @click.prevent="toggleCollapse">
                            <span v-show="!isCollapse"> {{ __("messages.read_more") }}</span>
                            <span v-show="isCollapse"> {{ __("messages.read_less") }}</span>
                        </a>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            msg: String,
            food: Object,
            city: String,
            countryName: String,

        },
        data() {
            return {
                name: "Weahter",
                isCollapse: false,
                vHeigth: '150px',
                vTransition: 'height 0.5s ease-out'
            };
        },
        methods: {
            toggleCollapse() {
                this.isCollapse = !this.isCollapse;

                if (!this.isCollapse) {
                    this.vHeigth = '150px';
                } else {
                    this.vHeigth = 'fit-content';
                    this.transition = 'height 0.5s ease-out';
                }

            }
        }
    };
</script>

